import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';
import { OVERVIEW_PAGE_PATH } from './constants';

const routes: LocalizedRoutes = {
  en: { path: OVERVIEW_PAGE_PATH['en'], meta: { requiresAuth: true, scrollToTop: true } },
  de: { path: OVERVIEW_PAGE_PATH['de'], meta: { requiresAuth: true, scrollToTop: true } },
  fr: { path: OVERVIEW_PAGE_PATH['fr'], meta: { requiresAuth: true, scrollToTop: true } },
  it: { path: OVERVIEW_PAGE_PATH['it'], meta: { requiresAuth: true, scrollToTop: true } },
};

const Component = () => import('@/pages/PropertyOverview/PropertyOverviewPage.vue');

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.PropertyOverview);

export default localizedRouteConfig;
